import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { marked } from 'marked'

export default /*@__PURE__*/_defineComponent({
  __name: 'TermsContentRommeMasters',
  setup(__props) {

function md(s: string) {
  return marked(s)
}

return (_ctx: any,_cache: any) => {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_modal_content = _resolveComponent("modal-content")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_modal_title, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('terms.rommemasters.title_rules')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_modal_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_t_text, {
          class: "terms-text rules",
          innerHTML: md(_ctx.$t('terms.rommemasters.content_rules'))
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    })
  ]))
}
}

})